import { EntityTemplateVariables } from '@tools/interfaces/template';
import { templateBookingEvent } from './template-booking-events';
import { getContactFieldsForEntity } from './template-contact';
import { templateOrder, templateOrderItem } from './template-order-and-order-items';
import { getDisciplineFieldsForEntity } from './template-discipline';
import { getArticleFieldsForEntity } from './template-article';
import { templateResource } from './template-resource';
import { getContractFieldsForEntity } from './template-contract';
import { getBookingFieldsForEntity } from './00-common-booking-fields';

export const templateBooking: EntityTemplateVariables = {
  fields: getBookingFieldsForEntity(''),
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.bookings.contact.label',
      description: 'templates.bookings.contact.description',
      fields: getContactFieldsForEntity('booking.'),
    },
    {
      relationName: 'contract',
      relationType: 'simple',
      label: 'templates.bookings.contract.label',
      description: 'templates.bookings.contract.description',
      fields: getContractFieldsForEntity('booking.'),
    },
    {
      relationName: 'discipline',
      relationType: 'simple',
      label: 'templates.bookings.discipline.label',
      description: 'templates.bookings.discipline.description',
      fields: getDisciplineFieldsForEntity('booking.'),
    },
    {
      relationName: 'article',
      relationType: 'simple',
      label: 'templates.bookings.article.label',
      description: 'templates.bookings.article.description',
      fields: getArticleFieldsForEntity('booking.'),
    },
  ],
  relatedInLoop: [
    {
      relationName: 'bookingEvent',
      relationType: 'inLoop',
      label: 'templates.bookings.booking_events.label',
      description: 'templates.bookings.booking_event.description',
      blockStartValue: '{% for booking_event in booking.bookingEvents %}',
      contentValue: '{# Add some bookingEvent fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateBookingEvent.fields,
    },
    {
      relationName: 'resources',
      relationType: 'inLoop',
      label: 'templates.bookings.resources.label',
      description: 'templates.bookings.resources.description',
      blockStartValue: '{% for resource in booking.resources %}',
      contentValue: '{# Add some resource fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateResource.fields,
    },
    {
      relationName: 'bookingEventsOrders',
      relationType: 'inLoop',
      label: 'templates.bookings.orders.label',
      description: 'templates.bookings.orders.description',
      blockStartValue:
        '{% for booking_event in booking.bookingEvents %}\n{% for order in booking_event.orders %}',
      contentValue: '{# Add some order fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateOrder.fields,
    },
    {
      relationName: 'orderItems',
      relationType: 'inLoop',
      label: 'templates.bookings.order_items.label',
      description: 'templates.bookings.order_items.description',
      blockStartValue:
        '{% for booking_event in booking.bookingEvents %}\n{% for order in booking_event.orders %}\n{% for orderItem in order.orderItems %}',
      contentValue: '{# Add some orderItem fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}\n{% endfor %}',
      fields: templateOrderItem.fields,
    },
  ],
};
